module.exports = __webpack_public_path__ + "assets/images/05_582549219955fc8e199f143bfb18192d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/05.png
// module id = 182
// module chunks = 0